module.exports = __webpack_public_path__ + "intuit-card-bottom-left@2x.1y0BxafU.png";